import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {Link} from 'gatsby';

function Podcastlisting(porps) {

    return (
        <div className="podcast_listing tekrevol_gray_bg p-100">
            <Container>
                <Row>
                    <Col xs={12} md={12} lg={10} xl={10} xxl={10} className="mb-5">
                        <div className="example" data-text="Podcast Ep">
                            <h2>Latest Episodes</h2>
                        </div>
                        <p>We collaborate with entrepreneurs and industry leaders to emphasize the importance of digital
                            transformation. We regularly invite technopreneurs and change leaders to talk about how
                            technology played a crucial role in transforming their businesses and how it helps them
                            scale up with sustainability.</p>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                        <div className="podcast_list">
                            <h4>AI in Digital Media with Kate Bradley Chernis</h4>
                            <div className="podcast_txt">
                                <p>In the seventh episode of our podcast series, "Technology for a Change," our host and Principal Product Strategist, Mr. Hady Shaikh, has invited Ms. Kate Bradley Chernis, an AI-...</p>
                            </div>
                            <Link to="https://tekrevol.theservtech.com/podcastdetail/technology-change-season3-episode07"
                                  className="btn_podcast"> Listen to this Episode
                            </Link>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                        <div className="podcast_list">
                            <h4>How to make Self-Believe your Superpower!</h4>
                            <div className="podcast_txt">
                                <p>Technology for a Change is back with its new episode of Season 3!. This time our host and Principal Product Strategist, Hady Shaikh, has invited Ms. Aaliya Rajah, a personal and...</p>
                            </div>
                            <Link to="https://tekrevol.theservtech.com/podcastdetail/technology-change-season3-episode06"
                                  className="btn_podcast"> Listen to this Episode
                            </Link>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                        <div className="podcast_list">
                            <h4>Small Businesses, Big Wins!</h4>
                            <div className="podcast_txt">
                                <p>In the 5th episode of #TechnologyForAChange, our Co-founder and CMO, Abeer Raza, sits down with Jeremy Harbour, Founder of Unity Group and Harbour Club...</p>
                            </div>
                            <Link to="https://tekrevol.theservtech.com/podcastdetail/technology-change-season3-episode05"
                                  className="btn_podcast"> Listen to this Episode
                            </Link>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );

}


export default Podcastlisting;